module.exports = __webpack_public_path__ + "img/r4.0a34427f.jpg";